import service from '@/store/services/fms/vehicle_ownership-service';

const state = {
  list: {},
  vehicle_ownership: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, vehicle_ownership) => {
    state.vehicle_ownership = vehicle_ownership;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },


  get({commit, dispatch}, params) {
    return service.get(params)
      .then((vehicle_ownership) => { commit('SET_RESOURCE', vehicle_ownership); });
  },


  add({commit, dispatch}, params) {
    return service.add(params)
      .then((vehicle_ownership) => { commit('SET_RESOURCE', vehicle_ownership); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((vehicle_ownership) => { commit('SET_RESOURCE', vehicle_ownership); });
  },


  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

  
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  vehicle_ownership: state => state.vehicle_ownership,
  page: state => state.meta.page,

};
 
const vehicle_ownership = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default vehicle_ownership;
